import React, { useState } from "react";
import { FileBadge } from "lucide-react";
import EmployeeReferralRewardMatrixContents from "./components/EmployeeReferralRewardMatrixContents";
import FullHeaderComponent from "../components/FullHeaderComponent";

const EmployeeReferralRewardMatrix= () => {
  const [searchTerm, setSearchTerm] = useState("");
  
  const handleSearch = (params) => {
      setSearchTerm(params?.keyword || "");
  };

  return (
    <div className="flex flex-col -mx-3 sm:-mx-4 md:-mx-6 -mt-3 sm:-mt-4 md:-mt-6">
      <FullHeaderComponent
        icon={FileBadge}
        title="Employee Referral Reward Matrix"
        subtitle="Hyvid Philippines · Owner: Talent Acquisition"
        searchHandler={handleSearch}
        placeholder={"Search matrix..."}
      />
      <div>
        <EmployeeReferralRewardMatrixContents searchTerm={searchTerm}/>
      </div>
    </div>
  );
};

export default EmployeeReferralRewardMatrix;